<template>
  <div>
    <WZOverlay v-if="display && !isV2" :params="params"/>
    <WZOverlayV2
      ref="overlay"
      v-else-if="display && isV2"
      :params="params_v2"
    />
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import axios from 'axios';
import WZOverlay from '../components/WZOverlay.vue';
import WZOverlayV2 from '../components/WZOverlayV2.vue';

export default {
  name: 'DefaultOverlay',
  components: {
    WZOverlay,
    WZOverlayV2,
  },

  data() {
    return {
      timer: '',
      display: false,
      isV2: false,
      params: {
        styles: {
          overlay: {
            color: '#fff',
            backgroundColor: '#292A2F',
            borderRadius: 20,
            borderWidth: 3,
            borderColor: '#151717',
          },
          slider: {
            backgroundColor: '#4b19d7',
          },
          user: {
            backgroundColor: '#000',
            color: '#fff',
          },
        },
        data: {
          kd: 0,
          kpg: 0,
          dpg: '6.00',
          wp: 0,
          hp: 0,
          first_kd: 0,
          first_wins: 0,
          first_kpg: 0,
          last_kpg: '0',
          last_matches: 0,
          headshot: 0,
          wins: 0,
          gulag: '0',
          user: {
            avatar: null,
            name: 'reddyrus',
          },
        },
        options: {
          stats: {
            name: 'alltime',
            visible: false,
          },
          user: {
            visible: false,
          },
          sets: {
            set1: {
              value: 'kd',
              label: 'KD',
            },
            set2: {
              value: 'wins',
              label: 'WINS',
            },
            set3: {
              value: 'kpg',
              label: 'KPG',
            },
            set4: {
              value: 'last_kpg',
              label: 'KILL/GAME',
            },
            set5: {
              value: 'gulag',
              label: 'GULAG',
            },
            set6: {
              value: 'last_matches',
              label: 'LAST n GAMES',
            },
          },
        },
      },
      params_v2: {
        text: null,
        styles: {
          overlay: {
            textColor: '#ffffff',
            labelColor: '#ffffff',
            backgroundColor: '#292A2F',
            borderRadius: 20,
            borderWidth: 3,
            borderColor: '#151717',
          },
          slider: {
            textColor: '#ffffff',
            labelColor: '#ffffff',
            backgroundColor: '#4b19d7',
          },
          user: {
            backgroundColor: '#000',
            color: '#fff',
            borderRadius: 20,
          },
          session: {
            backgroundColor: '#000',
            color: '#fff',
            borderRadius: 20,
          },
          stats: {
            backgroundColor: '#000',
            color: '#fff',
            borderRadius: 20,
          },
          placements: {
            backgroundColor: '#151717',
            firstColor: '#4b19d7',
            otherColor: '#000000',
            borderRadius: 0,
          },
        },
        data: {
          kd: 0,
          kpg: 0,
          dpg: 0,
          wp: 0,
          hp: 0,
          first_kd: 0,
          first_wins: 0,
          first_kpg: 0,
          last_kpg: 0,
          headshot: 0,
          last_matches: 0,
          wins: 0,
          gulag: 0,
          user: {
            avatar: null,
            name: '',
          },
          placements: [1, 1, 34, 23, 41, 33, 123, 1, 1, 34],
        },
        options: {
          stats: {
            key: 'alltime',
            visible: false,
          },
          user: {
            visible: true,
          },
          placements: {
            visible: false,
          },
          session: {
            timer: 0,
            visible: false,
          },
          slides: [],
        },
      },
    };
  },

  created() {
    this.init();
    this.updateData();
    if (window.location.search !== '?up=1') {
      this.timer = setInterval(this.updateData, 300000);
    }
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    init() {
      const { uid } = this.$route.params;
      axios.get(`https://api.wzhub.gg/api/overlay/${uid}${window.location.search}`).then((response) => {
        if (response.data.success) {
          this.display = true;
          this.isV2 = response.data.v2;
          if (response.data.v2) {
            this.params_v2.styles = response.data.overlay.styles;
            this.params_v2.data.user = response.data.overlay.user;
            this.params_v2.options = response.data.overlay.options;
            this.params_v2.options.slides = response.data.overlay.options.slides;
            this.params_v2.text = response.data.text;
          } else {
            this.params.styles = response.data.overlay.styles;
            this.params.data.user = response.data.overlay.user;
            this.params.options.user.visible = response.data.overlay.visible.user;
            this.params.options.stats.visible = response.data.overlay.visible.stats;
            this.params.options.stats.value = response.data.text;
          }
        } else {
          this.display = false;
        }
      }).finally(() => {
      });
    },

    updateData() {
      const { uid } = this.$route.params;
      axios.get(`https://api.wzhub.gg/api/overlay/${uid}/stats${window.location.search}`).then((response) => {
        if (response.data.success) {
          if (response.data.v2) {
            this.params_v2.data.first_kd = response.data.user.first_kd;
            this.params_v2.data.first_wins = response.data.user.first_wins;
            this.params_v2.data.first_kpg = response.data.user.first_kpg;
            this.params_v2.data.gulag = response.data.user.gulag;
            this.params_v2.data.kpg = response.data.user.kpg;
            this.params_v2.options.session.timer = response.data.user.session_start;
            this.params_v2.data.placements = response.data.user.places;
            this.params_v2.data.headshot = response.data.user.headshot;
            this.params_v2.data.winstreak = response.data.user.winstreak;
            this.params_v2.data.kill_record = response.data.user.kill_record;
            this.params_v2.data.kd = response.data.user.kd;
            this.params_v2.data.wins = response.data.user.wins;
            this.params_v2.data.last_matches = response.data.user.last_matches;

            this.$refs.overlay.updateSessionTimer();
          } else {
            this.params.data.kd = response.data.user.kd;
            this.params.data.wins = response.data.user.wins;
            this.params.data.kpg = response.data.user.kg;
            this.params.data.gulag = response.data.user.last_gulag;
            this.params.data.last_kpg = response.data.user.last_kg;
            this.params.data.last_matches = response.data.user.last_matches;
          }
        } else {
          this.display = false;
        }
      }).finally(() => {
      });
    },
  },
};
</script>
